// src/config.js
import { getSafeRedirect } from './utils/security';
const fromWindow = (key) =>
  typeof window !== 'undefined' && window.__ENV__ && typeof window.__ENV__[key] === 'string'
    ? window.__ENV__[key]
    : undefined;

const fromProcess = (key) =>
  typeof process !== 'undefined' && process.env && typeof process.env[key] === 'string'
    ? process.env[key]
    : undefined;

const getEnv = (key, fallback) => {
  const v = fromProcess(key) ?? fromWindow(key);
  return (typeof v === 'string' && v.length > 0) ? v : fallback;
};

const ensureTrailingSlash = (v) => (v && !v.endsWith('/') ? `${v}/` : v);

const backendReady = getEnv('REACT_APP_BACKEND_READY', 'true').toLowerCase() === 'true';

// Prefer configured API URL, else use current origin
const origin = (typeof window !== 'undefined' && window.location && window.location.origin) || 'http://localhost';
const baseUrlFromEnv = getEnv('REACT_APP_API_URL', origin);

// Force `/api/users` suffix
const apiBaseURL = ensureTrailingSlash(
  baseUrlFromEnv.endsWith('/api/users') || baseUrlFromEnv.endsWith('/api/users/')
    ? baseUrlFromEnv
    : `${baseUrlFromEnv}/api/users`
);

// Auth Service Base URL
const authBaseURL = ensureTrailingSlash(
  getEnv('REACT_APP_AUTH_URL', 
    origin.includes('localhost') ? 'http://localhost:8001/auth' : `${origin}/auth`
  )
);

// Redirect URL
const redirectURL = getSafeRedirect(getEnv('REACT_APP_REDIRECT_URL', 'http://localhost:3000'));

const config = {
  isBackend: backendReady, // Enable backend API calls only when backend is ready

  baseURLApi: apiBaseURL,
  redirectURL,
  app: {
    colors: {
      dark: '#0e1a2a',
      light: '#ffffff',
      primary: '#1B1F3B',
      secondary: '#798892',
      success: '#21AE8C',
      info: '#1A86D0',
      warning: '#FDA700',
      danger: '#FD5F00',
      inverse: '#0D1B2A',
      purple: '#D309E1',
      pink: '#ec3b83',
      white: '#fff',
      gray: '#3F4657',
    },
  },
  django: {
    baseURL: apiBaseURL,
    authBaseURL: authBaseURL,
    csrfCookieName: getEnv('REACT_APP_CSRF_COOKIE_NAME', 'csrftoken'),
    csrfTokenHeader: getEnv('REACT_APP_CSRF_TOKEN_HEADER', 'X-CSRFToken'),
    apiEndpoints: {
      login: 'login',
      logout: 'logout',
      me: 'auth/me/',
      refresh: 'refresh',
      switchService: 'switch-service'
    }
  }
};

export default config;
